import Modal from './Modal';

const els = document.querySelectorAll('.modal');

for (let el of els) {
    new Modal(el);
}
